<script>
import {notificationMethods, personMethods, personGroupMethods} from "@/state/helpers";

import { required, email } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Plasiyerler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      persons: [],
      personGroups: [],
      title: "Plasiyerler",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Plasiyerler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal:false,
      addForm: {
        name: "",
        email: "",
        phone: "",
        groupId: "",
      },
      editForm: {
        name: "",
        email: "",
        phone: "",
        groupId: "",
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search:'',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Adı",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
        },
        {
          key: "phone",
          label: "Telefon",
          sortable: false,
        },
        {
          key: "groupId.name",
          label: "Grup",
          sortable: false,
        },
        {
          key: "createdAt",
          label:"Oluşturulma Tarihi",
          sortable: true,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput:1
    };
  },
  validations: {
    addForm: {
      name:{required},
      phone: { required },
      email: { required, email },
      groupId:{required},
    },
    editForm: {
      name:{required},
      phone: { required },
      email: { required, email },
      groupId:{required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch:{
    page(newPage){
      this.pageInput=newPage;
      this.getPersons(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        if(this.page===1){
          this.getPersons();
        }else{
          this.page=1;
        }
      }
    },
    'addForm.email':function(){
      this.addForm.email= this.addForm.email.toLowerCase()
    },
    'editForm.email':function(){
      this.editForm.email= this.editForm.email.toLowerCase()
    }
  },
  mounted() {
    this.getPersons();
    this.getPersonGroupsForFormSelect();
  },
  methods: {
    ...personMethods,
    ...personGroupMethods,
    ...notificationMethods,
    doSearch(){
      if(this.page===1){
        this.getPersons();
      }else{
        this.page=1;
      }
    },
    resetForm() {
      this.addForm = {
        name: "",
        email: "",
        phone: "",
        groupId: "",
      };
      this.editForm = {
        name: "",
        email: "",
        phone: "",
        groupId: "",
      };
      this.addSubmitted = false,
          this.editSubmitted = false;
    },
    getPersons(page=this.page){
      this.itemsLoaded=false;
      let filter={}
      if(this.filter){
        filter.name = this.filter;
      }
      this.fetchPersons({page,limit:this.perPage,search:this.search}).then(res=>{
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded=true;
      })
    },

    getPersonGroupsForFormSelect(){
      this.fetchPersonGroups({listType:'select'}).then(res=>{
        if(res.docs.length>0){
          this.personGroups = res.docs;
          this.addForm.groupId = res.docs[0].id;
        }
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {

       this.createPerson(this.addForm).then(()=>{
          this.toastMessage="Plasiyer başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getPersons();
          this.addForm.name = "";
          this.addForm.email = "";
          this.addForm.phone = "";
          this.addForm.groupId = "";
        })
      }
    },

    handleEditSubmit() {
      this.editSubmitted = true;
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {

        this.updatePerson({id:this.editId,data:this.editForm}).then(()=>{
          this.toastMessage="Plasiyer başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getPersons();
        })
      }
    },
    handleDeleteSubmit() {

      this.deletePerson(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Plasiyer başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getPersons();
      })

    },

    openEdit(person) {
      this.editForm.name =person.name;
      this.editForm.phone = person.phone;
      this.editForm.email = person.email;
      this.editForm.groupId = person.groupId._id;
      this.editId = person.id;
      this.editModal = true;
    },
    openDelete(person) {
      this.deleteId = person.id;
      this.deleteModal = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Plasiyer Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
                <template v-slot:cell(createdAt)="data">
                  {{data.item.createdAt| formatDate}}
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">

                      <!-- pagination -->
                      <input :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"  class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Plasiyer Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Telefon</label>
                <input
                    id="phone"
                    type="text"
                    v-model="addForm.phone"
                    class="form-control"
                    placeholder="Telefon giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.phone.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.phone.required"
                    class="invalid-feedback"
                >
                  Telefon girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="addForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.addForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="groupId">Group</label>
                <select name="groupId"
                        id="groupId"
                        v-model="addForm.groupId"
                        class="form-control"
                        :class="{
                    'is-invalid': addSubmitted && $v.addForm.groupId.$error,
                  }"
                >
                  <option value="">Grup Seçiniz</option>
                  <option v-for="personGroup in this.personGroups" :key="personGroup.id" :value="personGroup.id" >{{ personGroup.name }}</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.addForm.groupId.required"
                    class="invalid-feedback"
                >
                  Grup girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Plasiyer Ekle</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal v-model="editModal" title="Plasiyer Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Telefon</label>
                <input
                    id="phone"
                    type="text"
                    v-model="editForm.phone"
                    class="form-control"
                    placeholder="Telefon giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.phone.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.phone.required"
                    class="invalid-feedback"
                >
                  Telefon girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="editForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.editForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.editForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="groupId">Group</label>
                <select name="groupId"
                        id="groupId"
                        v-model="editForm.groupId"
                        class="form-control"
                >
                  <option>Grup Seçiniz</option>
                  <option v-for="personGroup in this.personGroups" :key="personGroup.id" :value="personGroup.id" >{{ personGroup.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Plasiyer Düzenle</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu plasiyeri silmek istediğinize emin misiniz? Silinmiş plasiyerler geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kullanıcıyı silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>

    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
